<template>
  <el-dialog
    align-center
    :visible.sync="visible"
    :show-close="true"
    title="上传审核结果"
    width="590px"
    @close="close"
  >
    <div class="lead_first" v-loading="loading">
      <span>选择文件：</span>
      <el-upload
        :before-upload="beforeUpload"
        :on-success="handleUpload"
        :on-error="handleError"
        :show-file-list="false"
        :data="{ activityId: activityId }"
        ref="upload"
        :action="action"
        multiple
      >
        <jd-button type="blue" style="margin-left: 19px">
          点击上传文件
        </jd-button>
      </el-upload>
    </div>
    <jd-tip class="tip-bottom">
      <div>
        <p>
          1. 下载模板后编辑：提交记录id必填，不可变更模板；
          <jd-button type="blueText" @click="handleUrl">点击下载模板 </jd-button>
        </p>
        <p>
          2.只能上传需要通过审核的数据。通过人数不能超过剩余可通过人数。若导入超过可通过的数量，则后续的部分导入无效
        </p>
        <p>3. 已通过审核结果的不能进行变更</p>
        <p>4. 支持xls、xlsx格式上传，大小限制在50M内；</p>
      </div>
    </jd-tip>
    <div style="margin-top: 20px;padding-bottom:20px">
      成功处理{{ failureObj.successNum }}个，失败{{
        failureObj.failNum
      }}个，提交记录id：{{ failureObj.failIds.join(',') }}
    </div>
    <template v-if="failureObj.failNum > 0">
      <div
        style="margin-top: 10px; font-size: 16px"
        v-for="(item, index) in failureObj.failUserName"
        :key="index"
      >
        {{ item }}
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'UploadProccessResult',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    activityId: {
      type: String,
      default: '',
    },
    action: {
      require: true,
      type: String,
    },
  },
  data() {
    return {
      failureObj: {
        successNum: 0,
        failNum: 0,
        failIds: [],
      },
      loading: false,
      visible: false,
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      // 重置数据
      this.failureObj= {
        successNum: 0,
        failNum: 0,
        failIds: [],
      };
    },

    beforeUpload(file) {
      this.loading = true;
    },
    handleUpload(res) {
      if (res.code == 1) {
        this.failureObj.successNum = res.data.successNum;
        this.failureObj.failNum = res.data.failNum;
        this.failureObj.failIds = res.data.failIds;
        this.$emit('update')
      } else {
        this.$message.error(res.message);
      }
      this.loading = false;
    },
    handleError() {
      this.loading = false;
    },
    handleUrl() {
      const url =
        'https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E4%B8%8A%E4%BC%A0%E5%AE%A1%E6%89%B9%E7%BB%93%E6%9E%9C%E6%A8%A1%E7%89%88.xlsx';
      let elem = document.createElement('a');
      elem.style.display = 'none';
      elem.href = url;
      elem.setAttribute('download', '导入模板.xlsx');
      document.body.appendChild(elem);
      elem.click();
    },
  },
};
</script>

<style scoped lang="scss">
.lead_first {
  display: flex;
  align-items: center;
}

.tip-bottom {
  margin-top: 10px;
  /deep/ .left-tip-icon-box {
    display: none !important;
  }
}
</style>
